import AssignmentIcon from "@mui/icons-material/Assignment";
import SettingsIcon from "@mui/icons-material/Settings";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import LogoutIcon from "@mui/icons-material/Logout";
import SupportIcon from "@mui/icons-material/Support";
import i18next from "../../common/i18n";

export default (path) => {
    return [
        {
            Icon: AssignmentIcon,
            key: "audits",
            path: path.audits,
            primary: i18next.t("audits"),
            grantedPerms: "all",
        },
        {
            Icon: WarningAmberIcon,
            key: "excludeRemaining",
            path: path.excludeRemaining,
            primary: i18next.t("excludeRemaining"),
            grantedPerms: "restricted",
        },
        {
            Icon: CloudUploadIcon,
            key: "submitAudit",
            path: path.submitAudit,
            primary: i18next.t("submitAudit"),
            grantedPerms: "restricted",
        },
        {
            Icon: FileDownloadIcon,
            key: "exportAudit",
            path: path.exportAudit,
            primary: i18next.t("exportAudit"),
            grantedPerms: "restricted",
        },
        {
            Icon: SettingsIcon,
            key: "settings",
            path: path.settings,
            primary: i18next.t("settings"),
            grantedPerms: "all",
        },
        {
            Icon: SupportIcon,
            key: "troubleshoot",
            path: path.troubleshoot,
            primary: i18next.t("troubleshoot"),
            grantedPerms: "all",
        },
        {
            Icon: LogoutIcon,
            key: "logout",
            path: path.logout,
            primary: i18next.t("logout"),
            grantedPerms: "all",
        },
    ];
};
